export default __webpack_public_path__ + "static/media/content-deco-3.4ad4c4b6.webp";